module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: [_vm.sizeClasses]
  }, [_vm._t("default"), _vm._v(" "), (_vm.required) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), (_vm.infoTooltip) ? _c('span', {
    staticClass: "has-tooltip"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/info.svg"),
      "alt": "info"
    }
  }), _vm._v(" "), _c('BaseToolTip', {
    staticClass: "tooltip-text",
    attrs: {
      "text": _vm.infoTooltip,
      "tip": "bottom-right",
      "size": _vm.tooltipSize
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43ff782a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseLabel.vue
// module id = 111
// module chunks = 0